import { partial } from 'superstruct';

import { SortQueryDefaulted } from '@adflow/shared/util-data';

import type { ViewFacebookPageDto } from './facebook-page.dto';
import type { ViewFacebookTemplateDto } from './facebook-template.dto';

const FacebookTemplateSortableFields: (keyof ViewFacebookTemplateDto)[] = [
	'id',
	'name',
	'createdAt',
	'updatedAt',
	'archived',
	'salesforceImport',
] as const;

export const DEFAULT_FACEBOOK_TEMPLATE_SORT = 'updatedAt';
export const DEFAULT_FACEBOOK_TEMPLATE_SORT_DIR = 'desc';

export const ListFacebookTemplateSort = partial(
	SortQueryDefaulted(
		FacebookTemplateSortableFields,
		DEFAULT_FACEBOOK_TEMPLATE_SORT,
		DEFAULT_FACEBOOK_TEMPLATE_SORT_DIR
	)
);

const FacebookPagesSortableFields: (keyof ViewFacebookPageDto)[] = [
	'id',
	'name',
	'website',
	'link',
	'location',
	'avbId',
	'adAccountName',
] as const;

export const DEFAULT_FACEBOOK_PAGES_SORT = 'id';
export const DEFAULT_FACEBOOK_PAGES_SORT_DIR = 'desc';

export const ListFacebookPagesSort = partial(
	SortQueryDefaulted(
		FacebookPagesSortableFields,
		DEFAULT_FACEBOOK_PAGES_SORT,
		DEFAULT_FACEBOOK_PAGES_SORT_DIR
	)
);
